import { SelectionModel } from "@angular/cdk/collections";
import { Component, input, output } from "@angular/core";
import { MatSortModule, Sort } from "@angular/material/sort";
import { VendorSearchRow } from "../vendor-search/types/VendorSearchRow";
import { MatTableModule } from "@angular/material/table";
import { YesNoPipe } from "../../shared/pipes/yes-no.pipe";

@Component({
  selector: 'vendor-results-grid',
  templateUrl: 'vendor-results-grid.component.html',
  styleUrl: 'vendor-results-grid.component.scss',
  standalone: true,
  imports: [MatTableModule, MatSortModule, YesNoPipe]
})
export class VendorResultsGridComponent {
  public selection = new SelectionModel<VendorSearchRow>(false);

  public vendors = input<VendorSearchRow[]>([]);
  public onEdit = output<VendorSearchRow>();
  public sortChanged = output<Sort>();

  private defaultColumns: string[] = [
    "vendorName",
    "code",
    "type",
    "contact",
    "addressLine1",
    "addressLine2",
    "addressLine3",
    "country",
    "state",
    "city",
    "zip",
    "phone",
    "fax",
    "email",
    "active"
  ];
  protected readonly COLUMNS: string[] = [...this.defaultColumns] as const;

  protected doubleClick(row: VendorSearchRow) {
    if (!this.selection.isSelected(row))
      this.selection.toggle(row);

    this.onEdit.emit(row);
  }

  protected onSortChange(evt: Sort) {
    this.sortChanged.emit(evt);
  }
}
